<template>
  <div class="video-content">
    <div class="title">
      <!-- <img src="../../../../assets/icon/title_01.png" alt="" /> -->
      <div class="test">
        {{ title }}
      </div>
      <!-- <img src="../../../../assets/icon/title_02.png" alt="" /> -->
    </div>
    <video-player
      class="video-player vjs-custom-skin vjs-big-play-centered"
      :options="playerOptions"
    ></video-player>
    <div class="abstract">
      <span>简介</span>
    </div>
    <div class="remark" v-html="remark ? remark : '暂无'"></div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  components: { videoPlayer },
  data() {
    return {
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当 true 时，Video.js player 将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: this.url, // 路径
            type: "video/mp4", // 类型
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖 Video.js 无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 时间分割线
          durationDisplay: true, // 总时间
          remainingTimeDisplay: true, // 剩余播放时间
          progressControl: true, // 进度条
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.video-content .video-js .vjs-big-play-button {
  background: red !important;
  top: 50%;
  left: 50%;
}
</style>
<style scoped lang='scss'>
div {
  box-sizing: border-box;
}
.video-content {
  width: 100%;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    padding: 10px 14px;
    .test {
      padding: 12px 6px;
      text-align: center;
    }
    img {
      width: 20px;
    }
  }
  .abstract {
    padding: 20px 14px 8px 14px;
    span {
      padding: 8px 8px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      background: linear-gradient(
        to top,
        rgb(212, 234, 248) 0%,
        rgb(212, 234, 248) 50%,
        white 51%,
        white 100%
      );
    }
  }
  .remark {
    padding: 10px 18px;
    width: 100%;
    font-size: 14px;
    color: #666;
  }
}
</style>